import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '域名导航',
    links: [
      { label: '推荐域名', to: '/category/recommended' },
      { label: '主域名', to: '/category/main' },
      { label: '镜像域名', to: '/category/mirror' },
      { label: '备用入口', to: '/category/backup' },
      { label: '防失联域名', to: '/category/anti-lost' },
    ],
  },
  {
    title: '资源服务',
    links: [
      { label: '资源站点', to: '/category/resources' },
      { label: '使用指南', to: '/article/how-to-access-langyou' },
      { label: '技术科普', to: '/article/mirror-domain-explained' },
      { label: '平台动态', to: '/article/langyou-domain-history' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '联系方式', to: '/about' },
      { label: '常见问题', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-global-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl text-foreground-950">狼友域名</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专业域名导航与资源聚合平台，为站长和资源爱好者提供最新可用域名地址及防失联入口服务。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer" aria-label="Telegram">
                <i className="ri-telegram-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base text-foreground-950 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 狼友域名 LangYouYuMing. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">站点地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}